"use client";

import React, { useState } from "react";
import { useRouter } from "next/navigation";
import CourseCard from "../../components/cards/course-card";
import MentorConsultationModal from "../../components/forms/mentor-consultation-modal";
import InhouseTrainingModal from "../../components/forms/inhouse-training-modal";
import {
	openVideoLearning,
	openLiveWebinar,
	openMentorConsultation,
	COURSE_TYPES,
} from "../../utils/lms-navigation";

type CourseVarietyType =
	| typeof COURSE_TYPES.VIDEO_LEARNING
	| typeof COURSE_TYPES.LIVE_WEBINAR
	| typeof COURSE_TYPES.MENTOR_CONSULTATION
	| typeof COURSE_TYPES.INHOUSE_TRAINING;

const CourseVarietySection: React.FC = () => {
	const [mentorModalOpen, setMentorModalOpen] = useState(false);
	const [inhouseModalOpen, setInhouseModalOpen] = useState(false);
	const router = useRouter();

	const courseActions: Record<CourseVarietyType, () => void> = {
		[COURSE_TYPES.VIDEO_LEARNING]: openVideoLearning,
		[COURSE_TYPES.LIVE_WEBINAR]: openLiveWebinar,
		[COURSE_TYPES.MENTOR_CONSULTATION]: openMentorConsultation,
		[COURSE_TYPES.INHOUSE_TRAINING]: () => setInhouseModalOpen(true),
	};

	const handleCardClick = (courseType: CourseVarietyType) => {
		const action = courseActions[courseType];
		if (action) {
			action();
		}
	};

	const courses = [
		{
			type: COURSE_TYPES.VIDEO_LEARNING,
			title: "Video Learning",
			imageSrc: "/assets/images/video-learning.svg",
			imageAlt: "Video Learning",
		},
		{
			type: COURSE_TYPES.LIVE_WEBINAR,
			title: "Live Webinar Conference",
			imageSrc: "/assets/images/live-webinar.svg",
			imageAlt: "Live Webinar Conference",
		},
		{
			type: COURSE_TYPES.MENTOR_CONSULTATION,
			title: "Tư vấn Mentor",
			imageSrc: "/assets/images/mentor.svg",
			imageAlt: "Tư vấn Mentor",
		},
		{
			type: COURSE_TYPES.INHOUSE_TRAINING,
			title: "Đào tạo Inhouse",
			imageSrc: "/assets/images/inhouse.svg",
			imageAlt: "Đào tạo Inhouse",
		},
	];

	return (
		<>
			<section className="bg-white rounded-2xl p-6 mb-12">
				<h2 className="text-2xl font-semibold text-gray-800 mb-6">
					Đa dạng khóa học
				</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
					{courses.map((course) => (
						<CourseCard
							key={course.type}
							title={course.title}
							imageSrc={course.imageSrc}
							imageAlt={course.imageAlt}
							onClick={() => handleCardClick(course.type)}
						/>
					))}
				</div>
			</section>
			<MentorConsultationModal
				open={mentorModalOpen}
				onClose={() => setMentorModalOpen(false)}
			/>
			<InhouseTrainingModal
				open={inhouseModalOpen}
				onClose={() => setInhouseModalOpen(false)}
			/>
		</>
	);
};

export default CourseVarietySection;
